<template>
	<div class="page">

		<div class="tableBox">
			<div class="screenLine">
			<div class="screenLineR">
				<el-button type="warning" @click="edit({})">新增</el-button>
			</div>

		</div>
			<el-table :data="tableData" style="width: 100%" height="100%">
				<el-table-column prop="configId" label="配置编号">
				</el-table-column>
				<el-table-column label="消息类型">
					<template slot-scope="scope">
						<span v-if="scope.row.configType==0">通知</span>
						<span v-if="scope.row.configType==1">透传</span>
						<span v-if="scope.row.configType==2">消息</span>
					</template>
				</el-table-column>
				<el-table-column prop="configName" label="配置名称">
				</el-table-column>
				<el-table-column prop="templateContent" label="推送内容">
				</el-table-column>		
	 
				
				<el-table-column prop="remark" label="备注">
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<el-button @click="edit(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
      <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
			
		</div>
		<!-- 添加 编辑 -->
		<div v-if="drawerEdit_state">
			<drawerEdit :id="curItem" :type="type" @submit="submit_drawerEdit"></drawerEdit>
		</div>
	</div>
</template>

<script>
	import page from "../../../components/page.vue"
	import drawerEdit from "./drawer_edit.vue"
	export default {
		components: { page,drawerEdit},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0,
				},
				tableData: [], //表格数据
				
				drawerEdit_state: false,
				curItem: '', //跳转数据
			}
		},
		created() {

		},
		mounted() {
			this.getTableData()
		},
		methods: {
			edit(row){
				this.curItem = row.configId;
				this.drawerEdit_state = true
			},
			//删除
			del(row) {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let params = {
						id: row.configId
					}
					this.$http.delete(process.env.VUE_APP_zichan + '/api/Notice/config', params).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTableData()
						}
					})
				})
			},
			//关闭弹框
			submit_drawerEdit(obj) {
				this.drawerEdit_state = false;
				if (obj.type == "success") {
					this.getTableData()
				}
			},
			//获取表格
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			getTableData() {
				let params = {
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_zichan + '/api/Notice/config/list', params).then((res) => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.list;
						this.page.total = res.data.count;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		padding: 16px 16px 65px 16px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

		.screenLine {
			display: flex;

			.screenLineR {
				flex: 1;
				text-align: right;
			}

			.titleSelect {
				width: 130px;
				margin-right: 16px;
			}
		}

		.tableBox {
			padding: 16px;
			border-radius: 8px;
			background-color: #fff;
			box-sizing: border-box;
			margin-top: 16px;
			height: calc(100% - 56px);
		}

		.pagePosi {
			position: absolute;
			bottom: 0;
			left: 16px;
			right: 16px;
			text-align: right;
			background-color: #fff;
			padding: 0 10px;
			border-radius: 8px 8px 0 0;
		}
	}
</style>
